<mat-slide-toggle [(ngModel)]="value" [disabled]="isDisabled"></mat-slide-toggle>